import { BaseApiTemplateService, Core2Config } from "../../shared";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { WfProjectNotificationSubscriptionConfigContainerModel } from "../../../../../../models/aggregates/wf/project/wf-project-notification-subscription-config-container.model";

@Injectable({ providedIn: 'root' })
export class WfProjectNotificationSubscriptionConfigService extends BaseApiTemplateService<WfProjectNotificationSubscriptionConfigContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'project-notification-subscription-configs';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'project-notification-subscription-configs';
    this.httpClient = http;
  }
}
